import React, {useRef, useState, useMemo} from 'react'
import JoditEditor from "jodit-react";
import { FormCustom } from '../../Components/Form/Form'
import { useEffect } from 'react';
import Controllers from '../../Api/Controllers';
import { useCallback } from 'react';
import Helpers from '../../Components/Helpers/Helpers';
import { SurfaceCard, PageHeader } from '../../Components/Ui'
import {toast} from 'react-toastify'
import ReactPlaceholder from 'react-placeholder/lib';
import { useHistory } from 'react-router-dom';

const btnPrimary = {
    borderRadius: 12,
    fontWeight: 700,
    minHeight: 42,
    width: '100%',
    padding: '0 18px',
    background: '#201030',
    color: '#fff',
    border: 'none',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8
}

const YoSoy = ({ readonly }) => {
    const [ yo_soy, setYoSoy ] = useState({})
    const [ready, setReady] = useState(false)

    const history = useHistory()

    const config = useMemo(() => {
        if (readonly) {
            return {
                minHeight: 450,
                preset: 'inline',
                readonly
            }
        } else {
            return {
                minHeight: 450,
                language: 'es',
                askBeforePasteHTML: false,
                askBeforePasteFromWord: false,
            }
        }
    }, [readonly])

    useEffect(() => {
        Controllers.text.get_yo_soy().then(res => {
            setYoSoy(res.data)
            setReady(true)
        })
    }, [])

    const editorYoSoy = useRef(null)

    const contentHTMLYoSoy = useMemo(() => {
        return <>
        <JoditEditor
            ref={editorYoSoy}
            value={yo_soy?.content_text ? yo_soy.content_text : ''}
            config={config}
            tabIndex={1}
            onBlur={_ => {
                setYoSoy({ ...yo_soy, content_text: editorYoSoy.current.value })
            }}
        /></>
    }, [editorYoSoy, config, yo_soy])

    const dataSubmit = useCallback(() => {
        return {
            p_yo_soy: yo_soy,
        }
    }, [yo_soy])

    const [loadSubmit, setLoadSubmit] = useState(false)

    const handleSubmit = ({ data }) => {
        setLoadSubmit(true)
        Controllers.text.yo_soy_update(data).then(res => {
            Helpers.toast.construct({ ...res, toast, message: 'Cambios guardados correctamente.' })
            history.push(Helpers.config.convertUrl({ url: '/yo-soy-super' }))
        }).catch(req => Helpers.promise.catch({ req, toast }))
        .finally(() => {
            setLoadSubmit(false)
        })
    }

    return <>
        <PageHeader
            eyebrow="Super Papelera — Espacio de trabajo"
            title="Yo Soy Súper"
            subtitle="Edita el contenido de Yo Soy Súper."
        />
        <ReactPlaceholder ready={ready} showLoadingAnimation rows={15}>
            <FormCustom dataSubmit={dataSubmit()} onSubmit={handleSubmit} loadSubmit={loadSubmit} viewSubmit={false}>
                <div className={'mb-2 col-12 col-md-' + (readonly ? '12' : '9')}>
                    <SurfaceCard>
                        <h3 className="text-center" style={{ color: '#201030', fontWeight: 700 }}>Yo Soy Súper</h3>
                        {contentHTMLYoSoy}
                    </SurfaceCard>
                </div>
                {readonly ? '' : <div className="col-12 col-md-3">
                    <SurfaceCard title="Actualizar">
                        <p style={{ color: '#6B7280', fontSize: '0.9rem' }}>
                            Da click en el botón para guardar los cambios realizados.
                        </p>
                        <button type="submit" style={btnPrimary}>
                            {loadSubmit
                                ? <i className="fa fa-circle-notch fa-spin" />
                                : <><i className="fa fa-plus" />Guardar Cambios</>}
                        </button>
                    </SurfaceCard>
                </div>}
            </FormCustom>
        </ReactPlaceholder>
    </>
}

YoSoy.defaultProps = {
    readonly: false
}

export default YoSoy
